import { Button, Col, Input, Row, Table, Modal, Switch, Popconfirm, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { AddTags } from "./AddTags";
// import { setHeaderName } from "../../../../services/SetHeaderName";
// import { AddPlanPricing } from "./AddPlanPricing";
import '../../style/Tags.scss'
import { deleteTagApi, listOfTagApi, updateTagApi } from "../../../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../../../config/constant";
import { useParams } from "react-router-dom";

export const TagsList = (props) => {
    const [isModalVisible, setIsModalVisible] = useState(false)
    const { id } = useParams()

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [tagsData, setTagsData] = useState()
    const [loading, setLoading] = useState(false)

    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const data = [
        {
            id: '1001',
            name: 'Complaining',
            note: 'This is Complain',
            tagged_by: "Mansi Bhojani",
            date: "31 Aug,2022",
            status: false,
        },
        {
            id: '1002',
            name: 'Complimentary',
            note: 'This is Complimentary',
            tagged_by: "Aakash Parekh",
            date: "03 Aug,2022",
            status: true,
        },
    ];

    const [value, setValue] = useState('');

    // get the list of all Tags
    const getListOfTags = () => {
        setLoading(true)

        listOfTagApi({ "patient_id": parseInt(id) })
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }


    // filter recipe category
    const filterTags = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.tag.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element?.user?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.note.toUpperCase().indexOf(data.toUpperCase()) !== -1
                ) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };
    // filter data according to user search input 
    useEffect(() => {
        filterTags(tagsData);
    }, [tagsData]);

    useEffect(() => {
        getListOfTags()
        // setDataSource(data)
    }, []);

    const deleteTag = (data) => {
        // console.log(data);
        deleteTagApi(data)
            .then((res) => {
                if (res.status === 200) {
                    notification.success({
                        message: "Tag Removed successfully",
                    });
                    getListOfTags()
                    props?.setTagData(props?.setTagData)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }


    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'name',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.id - b.id,
        //     // render: (text) => <a>{text}</a>,
        // },
        {
            title: 'Tag',
            dataIndex: 'tag',
            key: 'tag',
            // sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Note',
            dataIndex: 'note',
            key: 'note',
        },
        {
            title: 'Tagged By',
            dataIndex: 'user',
            key: 'user',
            render: (text, data) => <p className="mb-0">{text?.name}</p>
        },
        {
            title: 'Date',
            dataIndex: 'created_at',
            key: 'date',
            render: (text, data) => <p className="mb-0">{text?.split('T')[0]}</p>
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Popconfirm title="Sure to delete?" onConfirm={() => deleteTag(record.id)}>
                        <Button icon={<DeleteOutlined />} className="me-2" />
                    </Popconfirm>
                </div>
            ),
        },
    ];


    return (
        <>
            <div className="Tags">
                <Row className="mb-2">
                    <Col md={4} xl={2} className="align-self-center">
                        <Button onClick={() => setIsModalVisible(true)} className="submit-button  border-0 rounded ms-2 " icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />}>
                            Add
                        </Button>
                    </Col>
                    <Col md={8} xl={16} className="text-end align-self-center pe-4">
                        <h6 className="mb-0">Total Tags: {displayData.length > 0 ? displayData.length : 0} </h6>
                    </Col>
                    <Col md={12} xl={6} className="align-self-center pe-2">
                        <Input.Search placeholder="Search Tag"
                            onChange={(e) => { filterTags(e.target.value); setTagsData(e.target.value) }}
                            className="p-2" />
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Table
                            columns={columns}
                            dataSource={displayData}
                            // pagination={false}
                            rowKey="id"
                            scroll={{ x: "max-content" }}
                            className="w-100"
                        />
                    </Row>
                </Spin>
            </div>
            <Modal
                open={isModalVisible}
                footer={null}
                width={600}
                className="addTag rounded"
                onOk={handleOk} onCancel={handleCancel}
            >
                <AddTags
                    tagData={props?.tagData}
                    setTagData={props?.setTagData}
                    getListOfTags={getListOfTags} setIsModalVisible={setIsModalVisible} />
            </Modal>
        </>
    )
}
